<p-toast position="top-center"></p-toast>

<p-dialog
    [(visible)]="loading"
    [showHeader]="false"
    [resizable]="false"
    [modal]="true"
    [focusOnShow]="false"
    class="progress-overlay">

    <div style="width: 200px; height: 150; padding-top: 5%" class="text-center">
        <p-progressSpinner
        [style]="{ width: '50px', height: '50px' }"
      ></p-progressSpinner>
    </div>
</p-dialog>

<div class="row medication-filters">
    <div class="col-md-3 ml-auto medication-group-filter">
        <p-multiSelect
            (onChange)="onMedGroupChange($event)"
            [options]="medGroupOptions"
            optionValue="value"
            [(ngModel)]="this.filter.medOptions"
            [filter]="true"
            class="multiSelectStyle">
        </p-multiSelect>
    </div>
    <div class="col-lg-2 ml-auto" id="serviceGrpApp">
        <app-service-grp-select (serviceGrpSelected)="onServiceGrpChanged($event)"></app-service-grp-select>
    </div>
    <div class="col-md-7 ml-auto" id="locationApp">
        <app-location-select 
            #locationSelectComp
            [user]="authService.user" 
            [footprint]="footprint"
            [deId]="deId" 
            [filter]="locationSelectFilter" 
            (locationSelected)="onLocationChanged($event)"
            (initComplete)="onLocationSelectInitialized($event)"
            >
        </app-location-select>
    </div>
</div>

<div class="row">
    <div class="col-12 pSelectBTN">
        <p-selectButton 
          (onChange)="updateLookbackPeriod($event)" [options]="days" [(ngModel)]="selectedDays" (dateValue)="updatedDate($event)">
        </p-selectButton>
    </div>
</div>

<div class="row firstRow">
    <div class="col-12 medication-overview-grid">
        <p-card header="Overall Occurrences" class="HeadLiner medication-overview-card">
            <h1>{{occurancecOverView}}</h1>
        </p-card>
        <p-card header="Total High Risk %" class="HeadLiner medication-overview-card">
            <h1>{{highRiskOverView}}%</h1>
        </p-card>
        <p-card header="Total Unaccounted" class="HeadLiner medication-overview-card">
            <h1>{{unaccountedOverView}}</h1>
        </p-card>
        <p-card header="Total Verified" class="HeadLiner medication-overview-card">
            <h1>{{verifiedOverView}}</h1>
        </p-card>
    </div>
    <div class="col-12 medication-table-section">
        <p-card header="Medication Grouping" class="medication-table-card">
            <div class="row">
                <div class="col-12">
                    <p-table 
                    #medGroupT
                    [value]="medicationGrouping" 
                    [paginator]="true" 
                    [rows]="15"
                    [sortField]="'unaccountedCount'"
                    [sortOrder]="-1"
                    [showCurrentPageReport]="true"
                    >
                        <ng-template pTemplate="header">
                            <tr>
                                <th [pSortableColumn]="'medGroupName'" class="medication-group-column">
                                    Medication Group
                                    <p-sortIcon field="medGroupName"></p-sortIcon>
                                </th>
                                <th [pSortableColumn]="'totalCount'" class="medication-count-column">
                                    Total Occurrences
                                    <p-sortIcon field="totalCount"></p-sortIcon>
                                </th>
                                <th [pSortableColumn]="'highRiskPercent'" class="medication-risk-column">
                                    High Risk %
                                    <p-sortIcon field="highRiskPercent"></p-sortIcon>
                                </th>
                                <th [pSortableColumn]="'unaccountedCount'" class="medication-unaccounted-column">
                                    Unaccounted 
                                    <p-sortIcon field="unaccountedCount"></p-sortIcon>
                                </th>
                                <th [pSortableColumn]="'verifiedCount'" class="medication-verified-column">
                                    Verified 
                                    <p-sortIcon field="verifiedCount"></p-sortIcon>
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData>
                            <tr>
                                <td>
                                    {{rowData.medGroupName}}
                                </td>
                                <td class="numeric-cell">
                                    <a tabindex="0" class="table-value-link"
                                        (click)="showRowData(rowData, 'totalCount')" (keydown.enter)="showRowData(rowData, 'totalCount')"
                                        >{{ rowData.occurrenceCount | number:'1.0-0' }}
                                    </a>
                                </td>
                                <td class="numeric-cell">
                                    <a tabindex="0" class="table-value-link"
                                        (click)="showRowData(rowData, 'highRiskPercent')" (keydown.enter)="showRowData(rowData, 'highRiskPercent')"
                                        >{{ rowData.highRiskPercent | number:'1.2-2' }}%
                                    </a>             
                                </td>
                                <td class="numeric-cell">
                                    <a tabindex="0" class="table-value-link"
                                        (click)="showRowData(rowData, 'unaccountedCount')" (keydown.enter)="showRowData(rowData, 'unaccountedCount')"
                                        >{{ rowData.unaccountedCount }}
                                    </a>
                                </td>
                                <td class="numeric-cell">
                                    <a tabindex="0" class="table-value-link"
                                        (click)="showRowData(rowData, 'verifiedCount')" (keydown.enter)="showRowData(rowData, 'verifiedCount')"
                                        >{{ rowData.verifiedCount }}
                                    </a>
                                </td>
                            </tr>                  
                        </ng-template>
                    </p-table> 
                </div>
            </div>
        </p-card>
    </div>     
</div>
<div class="row secondRow">
    <div class="col-12">
        <p-card header="Top 10 Medication Groups" class="PieChart medication-chart-card">
            <div class="row">
                <div class="col-sm-3">
                    <p-chart type="doughnut" [data]="totalOccurrances" [options]="occuranceOptions"></p-chart>
                </div>
                 <div class="col-sm-3">
                    <p-chart type="doughnut" [data]="highRiskPerc" [options]="highRiskOptions"></p-chart>
                </div>
                <div class="col-sm-3">
                    <p-chart type="doughnut" [data]="unaccountedMed" [options]="unaccountedOptions" ></p-chart>
                </div>
                <div class="col-sm-3">
                    <p-chart type="doughnut" [data]="verifiedCount" [options]="verifiedOptions" [plugins]="plugin" ></p-chart>
                </div>
            </div>
        </p-card>
    </div>
</div>


<!-- DIALOGS -->
<p-dialog [header]=" (selectedVerifiedRow?.medGroupName ? ' - ' + selectedVerifiedRow.medGroupName : '') + ' Details'" [(visible)]="filterTable" [style]="{width: '90vw'}">
    <app-data-filter-pills 
      [filterValues]="rowFilter" 
      [deId]="deId" 
      (filterVal)="removeFilter()" 
      (filterInputs)="openFilterModule($event)">
    </app-data-filter-pills>
    <app-urc
      #varianceComponent
      *ngIf="filterTable"
      [auditRow]="rowFilter"
      [deId]="deId"
      [isAuditor]="true"
      [lookbackPeriod]="filter.duration"
    ></app-urc>
</p-dialog>
